/*
  "Why You'll Love It" drawer for the mix & match bundle page.

  One drawer (snippets/mix-why-love-drawer.liquid) is shared by every product
  card. Each trigger carries data-mix-why-open with the id of the <template>
  holding that collection's content, so the drawer body is built on first open
  rather than duplicated into every card.

  Listeners are delegated from document, which means cards added later (tab
  switches, carousel cloning) work without re-binding.
*/
(function () {
  'use strict';

  var drawer, panel, body, lastFocus;

  function init() {
    drawer = document.getElementById('mix-why');
    if (!drawer) return false;
    panel = drawer.querySelector('.mix-why__panel');
    body = drawer.querySelector('[data-mix-why-body]');
    return true;
  }

  function closeHotspots() {
    if (!body) return;
    body.querySelectorAll('.mix-why__hs.is-active').forEach(function (hs) {
      hs.classList.remove('is-active');
      var dot = hs.querySelector('.mix-why__dot');
      if (dot) dot.setAttribute('aria-expanded', 'false');
    });
  }

  function open(trigger) {
    if (!drawer && !init()) return;

    var tpl = document.getElementById(trigger.getAttribute('data-mix-why-open'));
    if (!tpl || !('content' in tpl)) return;

    lastFocus = trigger;

    body.textContent = '';
    body.appendChild(tpl.content.cloneNode(true));

    // The template is shared by the whole collection, so the label it ships is a
    // collection-level fallback. Overwrite it with the title of the card that
    // was actually clicked.
    var label = trigger.getAttribute('data-mix-why-label');
    var labelEl = body.querySelector('.mix-why__label');
    if (label && labelEl) labelEl.textContent = label;

    drawer.hidden = false;
    // Next frame, so the transition runs from the hidden state rather than
    // being skipped because the element was display:none in the same tick.
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
    });

    document.body.classList.add('overflow-hidden');
    if (panel) panel.focus();
  }

  function close() {
    if (!drawer || drawer.hidden) return;

    drawer.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    closeHotspots();

    var finish = function () {
      drawer.hidden = true;
      // Drop the cloned images so a closed drawer holds no decoded bitmaps.
      body.textContent = '';
    };

    // Wait out the slide-out, but never leave the drawer stuck open if the
    // transition never fires (reduced motion, background tab).
    var done = false;
    var settle = function () {
      if (done) return;
      done = true;
      finish();
    };
    panel.addEventListener('transitionend', settle, { once: true });
    setTimeout(settle, 400);

    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    lastFocus = null;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mix-why-open]');
    if (trigger) {
      e.preventDefault();
      open(trigger);
      return;
    }

    if (!drawer || drawer.hidden) return;

    if (e.target.closest('[data-mix-why-close]')) {
      e.preventDefault();
      close();
      return;
    }

    var dot = e.target.closest('.mix-why__dot');
    if (dot && drawer.contains(dot)) {
      var hs = dot.closest('.mix-why__hs');
      var wasOpen = hs.classList.contains('is-active');
      closeHotspots();
      if (!wasOpen) {
        hs.classList.add('is-active');
        dot.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    // A click anywhere in the drawer that is not a hotspot or its popup closes
    // whichever popup is showing, matching the product page behaviour.
    if (drawer.contains(e.target) && !e.target.closest('.mix-why__popup')) {
      closeHotspots();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !drawer || drawer.hidden) return;
    // Esc backs out of an open hotspot first, then out of the drawer.
    if (body.querySelector('.mix-why__hs.is-active')) {
      closeHotspots();
      return;
    }
    close();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
